var e = [
  /Object Not Found Matching Id/i,
  /SymBrowser_/i,
  /Invalid call to runtime\.sendMessage/i,
  /Extension context invalidated/i,
  /ttdConversionEvents/i,
  /\bpixie\b/i,
  /HeavyAdIntervention/i,
  /ResizeObserver loop/i
], i = /[a-z][a-z0-9+.-]*:\/\/[^\s)'"]+/gi, t = "/assets/", n = "source";
export {
  e as NOISY_ERROR_MESSAGE_PATTERNS,
  t as OWN_BUNDLE_PATH_DEFAULT,
  i as STACK_FRAME_URL_RE,
  n as UNCAUGHT_RUM_ERROR_SOURCE
};

//# sourceMappingURL=datadogNoise.constants.js.map